import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getOrderTransactionsFilteredData } from '../../services/OrderTransactionServices';

export default function FilterModal({onClose , data }) {
    const { t } = useTranslation();
    const dispatch =useDispatch();

    const [filteredData, setFilteredData] = useState(data);

    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        BranchName: "",
        Type: "",
      });

      const handleFilterOrderTransactions = (e) => {
        e.preventDefault();
    
        const filteredResult = data.filter((item) => {
          const { BranchName , Type} = filterCriteria;
    
          let filterBranchName = true;
          let filterType     = true;
    
          if (BranchName) {
            filterBranchName = item?.BranchName?.toLowerCase()?.includes(BranchName.toLowerCase());
          }
    
          if (Type) {
            filterType = item?.Type.toLowerCase().includes(Type.toLowerCase());
          }

          return (
            filterBranchName &&
            filterType 
          );

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getOrderTransactionsFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.order_transactions.order_transactions_filter")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterOrderTransactions}
          >
            <Stack spacing={6}>
              <Input
                label={t("pages.order_transactions.branch")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.order_transactions.branch")}
                name="BranchName"
                value={filterCriteria.BranchName}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    BranchName: e.target.value,
                  })
                }
              />
              <Input
                label={t("pages.order_transactions.type")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.order_transactions.type")}
                name="Type"
                value={filterCriteria.Type}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    Type: e.target.value,
                  })
                }
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
}
